// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .article {
  line-height: 38px;
}
.presize-root .article,
.presize-root .article .ant-table,
.presize-root .article .ant-table td {
  transition: background 0.3s;
}
.presize-root .article:hover,
.presize-root .article:hover .ant-table,
.presize-root .article:hover td {
  background: #fafafa;
}
.presize-root .article:hover td.non-editable-cell {
  background: #efeff0;
}
.presize-root .article .article-details {
  padding-left: 56px !important;
}
.presize-root .selected-article,
.presize-root .selected-article .ant-table,
.presize-root .selected-article .ant-table td {
  background: #efeff0;
}
.presize-root .separator-selector,
.presize-root .article-selector {
  position: absolute;
  left: 32px;
}
.presize-root .separator-selector {
  top: 8px;
}
/*# sourceMappingURL=ArticleList.css.map */`, "",{"version":3,"sources":["webpack://./ArticleList.less","webpack://./src/components/SizingGroup/ArticleList/ArticleList.less"],"names":[],"mappings":"AAAA;EAEI,iBAAA;ACAJ;ADCI;;;EAGI,2BAAA;ACCR;ADCI;;;EAGI,mBAAA;ACCR;ADCI;EACI,mBAAA;ACCR;ADfA;EAiBQ,6BAAA;ACCR;ADII;;;EAGI,mBAAA;ACFR;ADvBA;;EA+BI,kBAAA;EACA,UAAA;ACJJ;AD5BA;EAoCI,QAAA;ACLJ;AACA,0CAA0C","sourcesContent":[".presize-root { \n .article {\n    line-height: 38px; // 37px table cell height + 1px border\n    &,\n    .ant-table,\n    .ant-table td {\n        transition: background .3s;\n    }\n    &:hover,\n    &:hover .ant-table,\n    &:hover td {\n        background: #fafafa;\n    }\n    &:hover td.non-editable-cell {\n        background: #efeff0;\n    }\n    .article-details {\n        padding-left: 56px !important;\n    }\n}\n\n.selected-article {\n    &,\n    .ant-table,\n    .ant-table td {\n        background: #efeff0;\n    }\n}\n\n.separator-selector,\n.article-selector {\n    position: absolute;\n    left: 32px;\n}\n\n.separator-selector {\n    top: 8px;\n}\n \n}",".presize-root .article {\n  line-height: 38px;\n}\n.presize-root .article,\n.presize-root .article .ant-table,\n.presize-root .article .ant-table td {\n  transition: background 0.3s;\n}\n.presize-root .article:hover,\n.presize-root .article:hover .ant-table,\n.presize-root .article:hover td {\n  background: #fafafa;\n}\n.presize-root .article:hover td.non-editable-cell {\n  background: #efeff0;\n}\n.presize-root .article .article-details {\n  padding-left: 56px !important;\n}\n.presize-root .selected-article,\n.presize-root .selected-article .ant-table,\n.presize-root .selected-article .ant-table td {\n  background: #efeff0;\n}\n.presize-root .separator-selector,\n.presize-root .article-selector {\n  position: absolute;\n  left: 32px;\n}\n.presize-root .separator-selector {\n  top: 8px;\n}\n/*# sourceMappingURL=ArticleList.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
